var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.marketingItemClasses },
    [
      _c("div", { staticClass: "upsell-marketing-item__text" }, [
        _c(
          "div",
          { staticClass: "upsell-marketing-item__text-label" },
          [
            _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.label) + "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "CompassTooltip",
              { attrs: { content: _vm.tooltipText } },
              [
                _c("CompassIcon", {
                  attrs: {
                    icon: "info-circle-fill",
                    size: "small",
                    type: "secondary"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.description.length > 0
          ? _c(
              "p",
              {
                staticClass:
                  "upsell-marketing-item__text-description typographies-paragraph-small-regular"
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.description) + "\n        "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.enabled
        ? _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.$t.__(
                  "pages.account.upsell.marketing.ChargebeeUpsellMarketingItemEmailPack.option_not_available"
                )
              }
            },
            [
              !_vm.enabled
                ? _c("CompassFeatureBadge", {
                    attrs: {
                      "is-interactive": false,
                      size: "small",
                      variant: "upsell"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CompassNumberInput", {
        attrs: {
          disabled: !_vm.enabled,
          min: 0,
          "model-value": _vm.numberChosen,
          step: 1
        },
        on: {
          change: function(quantity) {
            return _vm.onNumberChosenChange(quantity)
          }
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "upsell-marketing-item__price" }, [
        _c("span", { staticClass: "typographies-paragraph-medium-semibold" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$filters.numberFormatCurrency(
                  _vm.humanizeCentsPrice(_vm.amount)
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v(
            "\n            / " +
              _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _vm.enabled
        ? _c("div", { staticClass: "pack-marketing-email-supp__counter" }, [
            _c(
              "p",
              { staticClass: "pack-marketing-email-supp__counter-include" },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "typographies-paragraph-medium-regular pack-marketing-email-supp__counter-title"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Inclus")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$filters.numberFormatWithOptions(10000, {
                            precision: 0
                          })
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("p", [
              _c(
                "span",
                {
                  staticClass:
                    "typographies-paragraph-medium-regular pack-ma rketing-email-supp__counter-title"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Total")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$filters.numberFormatWithOptions(
                          10000 + 10000 * _vm.numberChosen,
                          {
                            precision: 0
                          }
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }